import "./OrderRow.css";

import { MdAccessTime } from "react-icons/md";

import StatusBadge from "../StatusBadge/StatusBadge";
import OrderActions from "../OrderActions/OrderActions";
import getImageUrl from "../../../../../utils/imageUrl";
function OrderRow({
  order,
  updateStatus,
  onView,
}) {

  const customerName =
    order.customerSnapshot?.name ||
    order.customerId?.name ||
    "Unknown Customer";

  const firstItem = order.items?.[0];

  const quantity =
    order.items?.reduce(
      (sum, item) => sum + item.quantity,
      0
    ) || 0;

  return (
    <tr>

      {/* Order Number */}
      <td>
        <strong>
          #{order.orderNumber?.slice(-6) ||
            order._id.slice(-6).toUpperCase()}
        </strong>
      </td>

      {/* Customer */}
      <td>

        <div className="customer-cell">

          <div className="customer-avatar">
            {customerName.charAt(0).toUpperCase()}
          </div>

          <div>
            <strong>{customerName}</strong>
          </div>

        </div>

      </td>

      {/* Food */}

      <td>

        <div className="food-cell">

     <img
  src={
    firstItem?.image
      ? getImageUrl(firstItem.image)
      : "/food-placeholder.png"
  }
  alt={firstItem?.foodName || "Food"}
  onError={(event) => {
    event.currentTarget.src = "/food-placeholder.png";
  }}
/>
          <div>

            <strong>

              {firstItem?.foodName || "Food"}

            </strong>

            {order.items.length > 1 && (

              <small>

                +{order.items.length - 1} more

              </small>

            )}

          </div>

        </div>

      </td>

      {/* Quantity */}

      <td>

        {quantity}

      </td>

      {/* Amount */}

      <td>

        ₹{order.grandTotal}

      </td>

      {/* Status */}

      <td>

        <StatusBadge
          status={order.status}
        />

      </td>

      {/* Time */}

      <td>

        <div className="time-cell">

          <MdAccessTime />

          {new Date(
            order.createdAt
          ).toLocaleTimeString([], {

            hour: "2-digit",

            minute: "2-digit",

          })}

        </div>

      </td>

      {/* Actions */}

      <td>

        <OrderActions
          order={order}
          updateStatus={updateStatus}
          onView={onView}
        />

      </td>

    </tr>
  );
}

export default OrderRow;